module.exports = __webpack_public_path__ + "static/media/iconWrite2.1c5ce0b5.svg";